import React, { useEffect, useState, useContext } from 'react'
import label from '../../../../../../../../assets/i18n/en.json'
import ProviderServicesService from '../../../../../../../services/api/provider-services.service';
import APIResponse from '../../../../../../templates/components/APIResponse';
import MessageSetting from '../../../../../../../common/constants/message-setting.constant';
import DimLoader from '../../../../../../templates/components/DimLoader';
import { store } from '../../../../../../../context/StateProvider';
import { useGetAllPracticeServiceTypes } from '../../../../../../../services/cache/CacheService';
const ProviderServicesTable = (props) => {
    const globalStateAndDispatch = useContext(store)
    const dispatch = globalStateAndDispatch.dispatch
    const [services, setServices] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const [isLookupLoader, setIsLookupLoader] = useState(false)
    const [serviceList, setServiceList] = useState()
    const [apiResponse, setApiResponse] = useState()
    const [successMessage, setSuccessMessage] = useState()
    const stateAllPracticeServiceTypeList = useGetAllPracticeServiceTypes()
    const [allServiceTypeList, setAllServiceTypeList] = useState()
    const onSuccess = (message) => {
        pullServices()
        dispatch({
            type: "setLocationProviderServices",
            payload: null
        });
    }

    useEffect(() => {
        //console.log("stateAllPracticeServiceTypeList ::"+ JSON.stringify(stateAllPracticeServiceTypeList))
        if (stateAllPracticeServiceTypeList) {
            setAllServiceTypeList(stateAllPracticeServiceTypeList)
        }
    }, [stateAllPracticeServiceTypeList])

    useEffect(() => {
        //console.log("allServiceTypeList ::"+ JSON.stringify(allServiceTypeList))
        if (allServiceTypeList) {
            pullServices()
        }
    }, [allServiceTypeList])

    const pullServices = () => {
        setServiceList()
        setServices()
        setIsLookupLoader(true)
        ProviderServicesService.findServicesByProvider(props.id)
            .then(res => {
                let selectedServices = res.data
                setServices(selectedServices)
                let allServiceTypes = allServiceTypeList.map(service => ({...service, providerHas: 0}))
                selectedServices.forEach(selectedService => {
                    const matchingService = allServiceTypes.find(obj => 
                        obj.practiceServiceTypeId === selectedService.practiceServiceTypeTypeDetails.practiceServiceTypeId
                    )
                    if (matchingService) {
                        matchingService.providerHas = 1
                    }
                })
                return setServiceList(allServiceTypes.filter(obj => !obj.providerHas))
            })
            .finally(() => {
                setIsLookupLoader(false)
            });
    }

    const removeService = (service) => {
        setIsLoader(true)
        let reqObj = {
            practiceServiceTypeId: service.practiceServiceTypeTypeDetails.practiceServiceTypeId,
            practitionerServiceTypeId: service.practitionerServiceTypeId,
            doctorId: props.id
        }
        ProviderServicesService.deleteProviderServiceById(reqObj)
            .then(res => {
                setSuccessMessage(MessageSetting.ProviderService.delete)
                setApiResponse(res)
            })
            .catch(err => {
                setApiResponse(err)
            })
            .finally(() => {
                setIsLoader(false)
            });
    }
    const addService = (practiceServiceTypeId) => {
        setIsLoader(true)
        let reqObj = { practiceServiceTypeId: practiceServiceTypeId, doctorId: props.id }
        ProviderServicesService.addProviderService(reqObj)
            .then(res => {
                setSuccessMessage(MessageSetting.ProviderService.add)
                setApiResponse(res)
            })
            .catch(err => {
                setApiResponse(err)
            })
            .finally(() => {
                setIsLoader(false)
            });
    }
    return (
        <>
            {isLoader || isLookupLoader ? <DimLoader loadMessage={isLookupLoader ? "Loading..." : label.common.processing} /> : null}
            <div className='d-flex row'>
                <div className='col-md-8 col-12'>
                    <div className='card'>
                        <div className='card-header'>Active Services</div>
                        <div className='card-body row d-flex'>
                            {services && services.map((service, i) => {
                                return (
                                    <div className='col-md-3 col-12' key={i}>
                                        <span title="Remove Service" className='text-start point' onClick={e => { e.preventDefault(); removeService(service) }}><i className='icon minus small' /> {service?.practiceServiceTypeTypeDetails?.practiceServiceType} </span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className='col-md-4 col-12'>
                    <div className='card'>
                        <div className='card-header'>Inactive Services</div>
                        <div className='card-body row d-flex'>
                            {serviceList && serviceList.map((service, i) => {
                                return (
                                    <div className='col-md-6 col-12' key={i}>
                                        <span title="Add Service" className='text-start point' onClick={e => { e.preventDefault(); addService(service.practiceServiceTypeId) }}><i className='icon plus small' /> {service?.practiceServiceType}</span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} successMessage={successMessage} />
        </>
    )
}

export default ProviderServicesTable